import { decrypt } from "./secret";
let lPK;

const key = "kkqwehuo";

const loadWasm = async () => {
  const memory = new WebAssembly.Memory({ initial: 256 });
  const envStub = {
    memory,
    emscripten_resize_heap: () => 0,
    _emscripten_memcpy_js: (d, s, n) => {
      const mem = new Uint8Array(memory.buffer);
      mem.set(mem.subarray(s, s + n), d);
      return d;
    },
    _abort_js: () => {},
    abort: () => {}
  };
  const wasiStub = {
    proc_exit: () => {},
    fd_close: () => 0,
    fd_write: () => 0,
    fd_seek: () => 0,
    fd_fdstat_get: () => 0,
    fd_read: () => 0,
    environ_sizes_get: () => 0,
    environ_get: () => 0,
    clock_res_get: () => 0,
    clock_time_get: () => 0
  };
  const importObject = {
    env: envStub,
    wasi_snapshot_preview1: wasiStub
  };
  const res = await fetch("prek.wasm");
  const bytes = await res.arrayBuffer();
  return (await WebAssembly.instantiate(bytes, importObject)).instance;
};

const getKey = async () => {
  const wasmModule = await loadWasm();
  const keyPtr = wasmModule.exports.get_hidden_key();
  const memory = new Uint8Array(wasmModule.exports.memory.buffer);
  let end = keyPtr;
  while (memory[end] !== 0) end++;
  const keyBytes = memory.slice(keyPtr, end);
  const publicKey = new TextDecoder().decode(keyBytes);
  wasmModule.exports.free_key(keyPtr);
  return publicKey;
};

export const getLPK = async () => {
  if (!lPK) {
    const k = await getKey();
    lPK = k
      .split("\n")
      .map(i => decrypt(i, key))
      .join("\n");
  }
  return lPK;
};
